export const STOREFRONT_BETA_FEEDBACK_URL =
  'https://form.asana.com/?k=EVFFjP2uJoiL3tbFp6ZqZQ&d=1126683767705082';

export const STOREFRONT_DEFAULT_APP = 'proxima';

export const STOREFRONT_CNAME_TLD = 'apps.swellstores.com';

export const STOREFRONT_LIMIT_COUNT = 50;

export const STOREFRONT_DEFAULT_PAGES = [
  {
    slug: 'about',
    name: 'About Us',
    content: `We are a company dedicated to providing the best products and services to our customers. Our mission is to deliver quality and value in everything we do.`,
  },
  {
    slug: 'contact',
    name: 'Contact',
    content: `[Your contact information here]`,
  },
  {
    slug: 'privacy',
    name: 'Privacy Policy',
    content: `[Your privacy policy here]`,
  },
  {
    slug: 'terms',
    name: 'Terms of Service',
    content: `[Your terms of service here]`,
  },
];

export const STOREFRONT_HOSTING_PROVIDERS = [
  { id: 'vercel', name: 'Vercel', description: '' },
  { id: 'netlify', name: 'Netlify', description: '' },
  { id: 'heroku', name: 'Heroku', description: '' },
  { id: 'cloudflare', name: 'Cloudflare', description: '' },
  { id: 'other', name: 'Other', description: '' },
];

export const STOREFRONT_LANGUAGES_FRAMEWORKS = [
  { id: 'nodejs', name: 'Node.js', description: '' },
  {
    id: 'ruby',
    name: 'Ruby',
    description: '',
  },
  { id: 'react', name: 'React', description: '' },
  { id: 'vuejs', name: 'Vue.js', description: '' },
  { id: 'angular', name: 'Angular', description: '' },
  { id: 'nextjs', name: 'Next.js', description: '' },
  { id: 'nuxtjs', name: 'NuxtJS', description: '' },
  { id: 'tailwindcss', name: 'Tailwind CSS', description: '' },
  { id: 'svelte', name: 'Svelte', description: '' },
  { id: 'graphql', name: 'GraphQL', description: '' },
  { id: 'java', name: 'Java', description: '' },
  { id: 'php', name: 'PHP', description: '' },
  { id: 'other', name: 'Other', description: '' },
];
